export default function () {
  const widgetName = 'footerBlock';
  const widgetOpts = footerBlockOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customWidget() {
        $(`#${widgetName} .card-widget-item`).each(function (i) {
          let desc = slide.items[i].Description
          let url = slide.items[i].URL
          $(this).find('.card-widget-description').remove()
          $(this).find('.buttonwrap').remove()
          $(this).find('.card-content').append(`<div class="new-description">${desc} <a href="${url}">More ></a></div>`)
        })
      }
      customWidget()
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'More >'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });
}